// extracted by mini-css-extract-plugin
export default {"container":"ContactPage_container__p8wM4","form":"ContactPage_form__BBBHj"};